module.exports = __webpack_public_path__ + "static/img/quadrante_mamario.29de2e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/quadrante_mamario.png
// module id = et7A
// module chunks = 1